export default "__VITE_ASSET__PxOybL2u__"